<template>
  <v-container fluid class="pa-0">
    <v-row class="ml-7 mt-5 row--header">
      <v-col cols="8" class="pb-0">
        <h4 class="secondary--font choose-image-title" :class="titleClass">{{ title }}</h4>
      </v-col>
      <v-col cols="4" class="text-right">
        <v-icon
          @click="closeDrawer"
          class="cross-icon cursor-pointer mr-8 pr-4 mt-2"
          v-track="'close-drawer'"
        >
          clear
        </v-icon>
      </v-col>
      <v-col cols="12" class="div--subtitle pb-0">
        <div class=" grey--text text--darken-2 body-1">
          {{ subTitle1 }}
        </div>
        <div class=" grey--text text--darken-2 body-1">
          {{ subTitle2 }}&nbsp;
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="4" md="2" >
        <basic-folder-tree
          :folder-name="'Image'"
          @changeFolder="updateFolderId"
        />
      </v-col>
      <v-col cols="8" md="10" class="grey lighten-4">
        <v-row no-gutters class="pa-8">
          <v-col cols="12" sm="12" offset-sm="12">
            <v-row v-if="images.length > 0" class="overflow-y-auto">
              <v-col
                v-for="item in images"
                :key="item.id"
                cols="4"
                sm="2"
                md="2"
                class="mb-4"
              >
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-img
                      v-if="isPdf(item)"
                      :src="item.image.url"
                      :lazy-src="item.image.url"
                      v-track="'image-library-image-view'"
                      @click.prevent="imageSelection(item)"
                      aspect-ratio="1"
                      class="grey lighten-2 cursor-pointer"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      src="@/assets/pdf.png"
                      lazy-src="@/assets/pdf.png"
                      v-track="'image-library-image-view'"
                      @click.stop="imageSelection(item)"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </v-hover>
                <a
                  :href="item.image.url"
                  class="text-decoration-none grey--text text--darken-4"
                  v-track="'image-library-item-preview'"
                  @click.prevent="imageSelection(item)"
                >
                  <span class="single-line-truncate d-block">
                    {{ item.name }}
                  </span>
                </a>
              </v-col>

              <v-col cols="12" v-intersect="loadMoreRecords">&nbsp;</v-col>
            </v-row>
            <v-row v-if="loading">
              <v-col cols="12" class="text-center">
                <v-progress-circular indeterminate size="40" />
              </v-col>
            </v-row>
            <v-row v-if="images.length == 0 && !loading && !cancelLoading">
              <v-col cols="12">
                <div class="text-center title" style="color:grey">
                  No Data Available!
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
/**
 * Choose Image Drawer 
 * A drawer component to pick image from image library
 * @author Rahul Rawat
 */
 import { mapGetters } from "vuex";
import { $images } from "@/services";
import BasicFolderTree from "@/components/ui/BasicFolderTree.vue";
import axios from 'axios';
export default {
  name: "ChooseImageDrawer",
  emits: ["update:value"],
  components: {
    BasicFolderTree
  },
  props: {
    title: {
      type: String,
      default: () => "Choose image from Image Library"
    },
  },
  data() {
    return {
      folderId: null,
      images: [],
      loading: false,
      pageNumber: 1,
      totalPage: 0,
      perPage: 10,
      listComplete: false,
      cancelLoading: false,
      cancelToken: axios.CancelToken.source(),
      
    };
  },
  computed:{
    ...mapGetters({
      drawer: "ui/drawer"
    }),
    subTitle1(){
      return this.drawer.right.type && this.drawer.right.type.includes('background') 
      ? "Choose image to appear as a background of the form."
      :  "Choose an image to set as the background behind your form while building it."
    },
    subTitle2(){
      return this.drawer.right.type && this.drawer.right.type.includes('background') ? ""
      : "This will help you match the layout of the form to your current webpage."
    },
    titleClass(){
      if(this.$vuetify.breakpoint.mdAndUp){
        return 'text-h1';
      } else {
        return 'title';
      }
    }
  },
  mounted() {
    this.getImages();
  },
  methods: {
    /**
     * Get image from image library based on folder id
     * @param {*} id -- folder Id
     */
    getImages(id = null) {
      this.loading = true;
      const page = this.pageNumber;
      const payload = {
        page,
        per_page: this.perPage
      };
      if (this.folderId) {
        payload.folder_id = this.folderId;
      }
      
      // api call
      $images
        .fetch({ 
          params: payload,
          cancelToken: this.cancelToken.token
        })
        .then(response => {
          if (page == 1) {
            this.images = [];
          }
          this.images = [...this.images, ...response.data.data];

          if (this.responseName !== "") {
            this.totalPage = Math.ceil(response.data.meta.count / this.perPage);
            this.listComplete = this.totalPage <= this.pageNumber ? true : false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * On update folderID call getImage method
     * @param {*} id -- Folder Id
     */
    updateFolderId(id) {
      this.cancelLoading = true;
      this.folderId = id;
      this.cancelToken.cancel();
      this.pageNumber = 1;
      this.cancelToken= axios.CancelToken.source()
      this.images=[]
      setTimeout(() =>{
        this.cancelLoading = false;
        this.getImages(id);
      })
    },
    /**
     * Update selected image on store 
     * @param {*} item 
     */
    imageSelection(item) {
      this.$store.commit("ui/drawer.right.update", {
        show: false,
        component: null,
        response: [item],
        width:undefined
      });
    },
    /**
     * Method to add infinite scroll functionality 
     */
    loadMoreRecords() {
      if (!this.listComplete && this.images.length > 0) {
        this.pageNumber += 1;
        this.getImages(this.folderId);
      }
    },
    /**
     * Check Image is PDF or not
     * @param {*} item - Image item object
     * @returns {Boolean} 
     */
     isPdf(item) {
      return (
        item.image.url.substring(
          item.image.url.length - 4,
          item.image.url.length
        ) !== ".pdf"
      );
    },
    /**
     * Close the drawer by updating store drawer.right property
     */
    closeDrawer(){
      this.$store.commit("ui/drawer.right.update", {
        show: false,
        component: null,
        response: [],
        width: undefined
      });
    }
  }
};
</script>
<style lang="scss" scoped>
h4.text-h1{
  font-size: 34px;
}
.row--header{
  margin-bottom: 22px;
}
.div--subtitle{
  margin-top: -2px;
}
.choose-image-title{
  font-size: 34px;
}
</style>
